import Vue from 'vue'
import VueRouter from 'vue-router'
import ChatHome from '../views/chat/ChatHome.vue'
import ChatChat from '../views/chat/ChatChat.vue'
import ChatFansHome from '../views/chat/fans/ChatFansHome.vue'
import ChatCustomHome from '../views/chat/custom/ChatCustomHome.vue'
import ChatClusterHome from '../views/chat/cluster/ChatClusterHome.vue'
import ChatHelperHome from '../views/chat/helper/ChatHelperHome.vue'
import ChatSettingHome from '../views/chat/setting/ChatSettingHome.vue'
import CircleHome from '../views/circle/CircleHome.vue'
import HistoryHome from '../views/history/HistoryHome.vue'
import HelpHome from '../views/help/HelpHome.vue'
import WorkHome from '../views/work/WorkHome.vue'
import Login from '../views/login/Login.vue'
import {getLoginInfo} from '../functions/Common.js'

Vue.use(VueRouter)

const routes = [
	// 默认路由
	{
		path: '/',
		redirect: '/chat/chat'
	},
	{
		path: '/chat',
		name: 'ChatHome',
		component: ChatHome,
		children: [
			{
				path: 'chat*',
				component: ChatChat,
				meta:{
					keepAlive:true
				}
			},
			{
				path: 'fans',
				component: ChatFansHome,
				meta:{
					keepAlive:true
				}
			},
			{
				path: 'custom',
				component: ChatCustomHome
			},
			{
				path: 'cluster',
				component: ChatClusterHome
			},
			{
				path: 'helper',
				component: ChatHelperHome,
				meta:{
					keepAlive:true
				}
			},
			{
				path: 'setting',
				component: ChatSettingHome
			}
		]
	},
	{
		path: '/circle/home',
		name: 'CircleHome',
		component: CircleHome,
		meta:{
			keepAlive:true
		}
	},
	{
		path: '/history/home',
		name: 'HistoryHome',
		component: HistoryHome,
	},
	{
		path: '/work/home',
		name: 'WorkHome',
		component: WorkHome,
	},
	{
		path: '/help/home',
		name: 'HelpHome',
		component: HelpHome,
	},
	{
		path: '/login/login',
		name: 'Login',
		component: Login,
	},
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 导航守卫
router.beforeEach((to,from,next)=>{
	let loginInfo = getLoginInfo()
	if(!loginInfo && to.name !== 'Login'){
		next({
			name:'Login'
		})
	}
	next()
})

export default router
